import styled from '@emotion/styled';
import {css} from '@emotion/react';
import {CgClose} from 'react-icons/cg';

// eslint-disable-next-line max-len
import {ReactComponent as HamburgerSVG} from '../../../assets/icons/ic_menu.svg';

import {Logo as LogoStyle} from '../../styles';

const LOGO_SIZE = '64px';
const SCROLL_POSITION_CURSOR_THRESHOLD = 15;
const SCROLL_POSITION_OPACITY_THRESHOLD = 5;
// higher value threshold to be used inside component
export const SCROLL_POSITION_BURGER_THRESHOLD = 20;

export const TopBarWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 997;
`;

export const TopBarContainer = styled.div`
  padding: ${({theme}) =>
    `${theme.margin.desktop.lg} ${theme.margin.desktop.md} 0 ${theme.margin.desktop.md}`};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const LeftSide = styled.div`
  display: flex;
  align-items: center;
`;

export const Logo = styled(LogoStyle)<{scrollPosition: number}>`
  width: ${LOGO_SIZE};
  height: ${LOGO_SIZE};
  cursor: ${({scrollPosition}) =>
    scrollPosition < SCROLL_POSITION_CURSOR_THRESHOLD ? 'pointer' : 'default'};
  opacity: ${({scrollPosition}) =>
    scrollPosition < SCROLL_POSITION_OPACITY_THRESHOLD ? 1 : 0};
  transition:
    opacity 0.3s ease-in-out,
    cursor 0.3s ease-in-out;
`;

export const Title = styled.h1`
  font-size: ${({theme}) => theme.typography.fontSize.lg};
  font-weight: bold;
`;

export const IconMargin = styled.div`
  width: ${LOGO_SIZE};
`;

const iconStyle = css`
  width: 40px;
  height: 40px;
`;

export const IconHamburger = styled(HamburgerSVG)`
  color: ${({theme}) => theme.color.neutral.grey_900};
  width: ${({theme}) => theme.icon.size.md};
  height: ${({theme}) => theme.icon.size.md};
  ${iconStyle}
`;

export const IconClosed = styled(CgClose)`
  ${iconStyle}
`;

export const IconWrapper = styled.div<{
  isMobileSidebarOpen: boolean;
  scrollPosition: number;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${LOGO_SIZE};
  height: ${LOGO_SIZE};
  border-radius: ${({theme}) => theme.border.radius.md};
  border: ${({isMobileSidebarOpen, theme}) =>
    isMobileSidebarOpen ? `2px solid ${theme.color.white}` : 'none'};
  background-color: ${({theme}) => theme.color.surface.niv1};
  box-shadow: ${({isMobileSidebarOpen, theme, scrollPosition}) => {
    if (isMobileSidebarOpen) {
      return 'none';
    } else if (scrollPosition < SCROLL_POSITION_BURGER_THRESHOLD) {
      return theme.boxShadow.primary;
    }
    return theme.boxShadow.secondary;
  }};
  transition:
    background-color 0.3s ease-in-out,
    box-shadow 0.3s ease-in-out;
  &:hover {
    cursor: pointer;
  }
`;
